import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(desc: string, ...args: any[]): string {
    const length = args.length ? args[0] : 100;
    return desc.length > length ? `${desc.slice(0, length)}...` : desc;
  }
}
